import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IntroductionRouting } from './introduction.routing';
import { IntroductionV2Service } from '@introduction/infra';
import { CompleteIntroductionCommandHandler } from './lib/application/handlers';

@NgModule({
  imports: [RouterModule.forChild(IntroductionRouting)],
  providers: [IntroductionV2Service, CompleteIntroductionCommandHandler]
})
export class IntroductionModule {}
